"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBidderDto = instanceOfBidderDto;
exports.BidderDtoFromJSON = BidderDtoFromJSON;
exports.BidderDtoFromJSONTyped = BidderDtoFromJSONTyped;
exports.BidderDtoToJSON = BidderDtoToJSON;
exports.BidderDtoToJSONTyped = BidderDtoToJSONTyped;
/**
 * Check if a given object implements the BidderDto interface.
 */
function instanceOfBidderDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function BidderDtoFromJSON(json) {
    return BidderDtoFromJSONTyped(json, false);
}
function BidderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'isVerified': json['isVerified'],
        'image': json['image'] == null ? undefined : json['image'],
    };
}
function BidderDtoToJSON(json) {
    return BidderDtoToJSONTyped(json, false);
}
function BidderDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'isVerified': value['isVerified'],
        'image': value['image'],
    };
}
